import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import SglContext from "../SglContext";
import "../loginForm/loginform.css";
import indicator_icon from "../images/Indicator.gif";
import { Helmet } from "react-helmet";
import Pusher from 'pusher-js';
import "../registrationForm/registrationForm.css";



const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

export default function AddBankAccount(props) {
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [bankConfirmed, setBankConfirmed] = useState(false);
  const [verifyMicroDeposit, setVerifyMicroDeposit] = useState(false);
  const [hostedMicroDepositUrl, sethostedMicroDepositUrl] = useState('');
  const [companyName, setCompanyName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [setupIntent, setSetupIntent] = useState(null);
  const [clientSecret, setClientSecret] = useState("");
  const [userDetail, setUserDetail] = useState({});
  const [showMandate, setShowMandate] = useState(false);
  const [bankAccount, setBankAccount] = useState(null);
  const Sgl = useContext(SglContext);

  // API ENDPOINTS
  const sgl_webservice_stripe_setup_intent =
    Sgl.sglApiUrl + "/iphone.php/webservice/StripeSetupIntent";
  const sgl_webservice_stripe_retrieve_payment_method =
    Sgl.sglApiUrl + "/iphone.php/webservice/StripeRetrieveBankDetail";
  const sgl_webservice_stripe_save_account =
    Sgl.sglApiUrl + "/iphone.php/webservice/StripeSaveBankAccount?XDEBUG_SESSION_START=netbeans-xdebug";
  const user_info_url =
    Sgl.nestApiUrl +'/users/getLoggedInUser';

  const getUserData = async () => {
    axios.get(user_info_url)
    .then((response) => {
      Sgl.checkLoginOnSGL();
      if(response.data.user && response.data.user != null){
      } else{
      }
    }, (error) => {
    });
  }

  useEffect(() => {
    setLoading(false);
    getUserData()
  }, []);

  useEffect(() => {
    if( errorMessage != '' ) {
      setProcessing(false);
    }
  }, [errorMessage]);

  useEffect(() => {
    if (processing) {
      setErrorMessage('')
    }
  }, [processing]);

  const handleBankVerification = async () => {
    setProcessing(true)
    try {
      let response = await axios.get(sgl_webservice_stripe_setup_intent, {
        params: { company_id: Sgl.company_id },
      });

      let clientSecret = response.data.setup_intent.client_secret;
      let userDetail = response.data.user_detail;
      let setupIntent = response.data.setup_intent

      setSetupIntent(setupIntent);
      setClientSecret(clientSecret);
      setUserDetail(userDetail);
      setCompanyName(response.data.company_name)

      if (!clientSecret) {
        setErrorMessage("Setup Intent not available.");
        return;
      }

      if (setupIntent.status === 'requires_action' && setupIntent.next_action?.type === "verify_with_microdeposits") {
        // The account needs to be verified via microdeposits.
        // Display a message to consumer with next steps (consumer waits for
        // microdeposits, then enters a statement descriptor code on a page sent to them via email).
        handleMicroDeposits(setupIntent)
      } else {
        await collectBankAccountForSetup(clientSecret , userDetail)
      }

    } catch (error) {
      setErrorMessage("An unexpected error occurred. Please try again.");
    }
  };
    
  const collectBankAccountForSetup = async ( clientSecret , userDetail ) => {
    setProcessing(true)
    try {
      const stripe = await stripePromise;
      const { setupIntent, error } = await stripe.collectBankAccountForSetup({
        clientSecret,
        params: {
          payment_method_type: "us_bank_account",
          payment_method_data: {
            billing_details: {
              name: userDetail.name,
              email: userDetail.email,
            },
          },
          expand: ['']
        },
      });

      if (error) {
        setErrorMessage(error.message);
        return;
      }

      if (setupIntent.status === "requires_payment_method") {
        setErrorMessage("Please complete the verification process on Stripe.");
        return;
      }

      if (setupIntent.status === "requires_confirmation") {
        await showMandateStep(setupIntent)
        return
      }

      setProcessing(false)

    } catch (error) {
      setErrorMessage("An unexpected error occurred. Please try again.");
    }
  };

  const showMandateStep = async ( setupIntent ) => {
    try {
      if (setupIntent.status === "requires_confirmation") {
        axios.get(sgl_webservice_stripe_retrieve_payment_method, {
          params: {
            company_id: Sgl.company_id,
            payment_method: setupIntent.payment_method,
          }
        }).then((response) => {
          setBankAccount(response.data.payment_method?.us_bank_account);
          setShowMandate(true);  
          setVerifyMicroDeposit(false);
          setProcessing(false)
        })
        .catch(() => {
          setErrorMessage("Failed to save bank details. Please try again.");
        });

      }
    } catch (error) {
      setErrorMessage("An unexpected error occurred. Please try again.");
    }
  };

  const handleConfirmMandate = async () => {
    setProcessing(true)
    try {
      const stripe = await stripePromise;
      const { setupIntent, error } = await stripe.confirmUsBankAccountSetup(clientSecret);

      if (error) {
        setErrorMessage(error.message);
        return;
      }

      if (setupIntent.status === "succeeded" || setupIntent.next_action?.type === "verify_with_microdeposits") {
        axios
          .post(sgl_webservice_stripe_save_account, {
            company_id: Sgl.company_id,
            payment_method: setupIntent.payment_method,
            setup_intent_id: setupIntent.id,
            setup_intent_status: setupIntent.status
          })
          .then((response) => {

            if (setupIntent.status === 'requires_action' && setupIntent.next_action?.type === "verify_with_microdeposits") {
              // The account needs to be verified via microdeposits.
              // Display a message to consumer with next steps (consumer waits for
              // microdeposits, then enters a statement descriptor code on a page sent to them via email).
              handleMicroDeposits(setupIntent)
            } else {
              setBankConfirmed(true);
            }
            
          })
          .catch(() => {
            setErrorMessage("Failed to save bank details. Please try again.");
          });
      } else {
        setErrorMessage("Bank verification was not completed successfully.");
      }
    } catch (error) {
      setErrorMessage("An unexpected error occurred. Please try again.");
    }
  };

  const handleMicroDeposits = async (setupIntent) => {
    setProcessing(true)
    axios.get(sgl_webservice_stripe_retrieve_payment_method, {
      params: {
        company_id: Sgl.company_id,
        payment_method: setupIntent.payment_method,
      }
    }).then((response) => {
      setBankAccount(response.data.payment_method?.us_bank_account);
      setShowMandate(true);  
      setProcessing(false)
    })
    .catch(() => {
      setErrorMessage("Failed to retrieve bank details. Please try again.");
    });

    setVerifyMicroDeposit(true)
    sethostedMicroDepositUrl(setupIntent.next_action.verify_with_microdeposits.hosted_verification_url)
    var pusher = new Pusher('b6232310f51498462640');
    var channel = pusher.subscribe('add-bank-account-'+setupIntent.id);
    channel.bind('updateavailable', function(setup_intent) {
        if(setup_intent.status == 'succeeded'){            
            setBankConfirmed(true);
        }
    });
  }

  if (loading) return null;

  return (
    <div className='sgl-content-wrapper registrationformcss' style={{'textAlign':'center'}}>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <div className='sgl-plugin'>
        <div className='registration_header' style={{display: (props.insideModal)?"none":"block"}}>
          <h1>{Sgl.company_name} - ADD BANK ACCOUNT</h1>
        </div>
        <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
        <br />
        <div id="sgl-plugin-email-success-message">
          {bankConfirmed ? (
          <div id='sgl-plugin-form'>
            <div 
                className="div-responsive"
                style={{
                  maxWidth: "600px",
                  margin: "auto",
                  padding: "20px",
                  fontFamily: "Arial, sans-serif",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9",
                }}
              >
              <h2 style={{ color: "#333", textAlign: "center" }}>
                Bank Account Verified!
              </h2>
              <p>
                Your bank account has been verified successfully for {companyName}!
              </p>
            </div>
          </div>
          ) : verifyMicroDeposit ? (
            <div id='sgl-plugin-form'>
              <div 
                className="div-responsive"
                style={{
                  maxWidth: "600px",
                  margin: "auto",
                  padding: "20px",
                  fontFamily: "Arial, sans-serif",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9",
                  textAlign: 'left'
                }}
              >
              <h2 style={{ color: "#333" }}>Verify Your Bank Account with Micro-Deposits</h2>
              <p style={{ color: "#555", fontSize: "16px", lineHeight: "1.5" }}>
                To ensure secure transactions, we need to verify your bank account using micro-deposits.
              </p>

              <div style={{ textAlign: "left", marginTop: "15px" }}>
                <p style={{ color: "#555", fontSize: "16px", lineHeight: "1.5" }}>
                  1️⃣ <strong>Check Your Bank Statement:</strong> In the next 1-2 business days, you’ll receive two small deposits (each under $1) in your bank account from Stripe.
                </p>
                <p style={{ color: "#555", fontSize: "16px", lineHeight: "1.5" }}>
                  2️⃣ <strong>Return Here to Enter the Amounts:</strong> Once you see the deposits, come back and enter the exact amounts to confirm your account.
                </p>
                <p style={{ color: "#555", fontSize: "16px", lineHeight: "1.5" }}>
                  3️⃣ <strong>Complete Verification:</strong> After entering the correct amounts, your bank account will be fully verified and ready for ACH payments.
                </p>
              </div>

              <p style={{ color: "#777", fontSize: "14px", fontStyle: "italic", marginTop: "15px" }}>
                💡 If you don’t see the deposits after 2 business days, please check with your bank or try linking your account again.
              </p>
              {bankAccount && (
                <p>
                  <strong>Bank Name:</strong> {bankAccount.bank_name} <br />
                  <strong>Account Number:</strong> {bankAccount.account_holder_name?`${bankAccount.account_holder_name} - `:""}*{bankAccount.last4}
                </p>
              )}
              {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

              {
              (!processing)?
              <>
              <div style={{ marginTop: "20px", textAlign: 'center' }}>
                <button
                  disabled={processing}
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    border: "none",
                    padding: "12px 20px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => window.open(hostedMicroDepositUrl, "_blank")}
                >
                  Enter Deposit Amounts
                </button>
              </div>

              <div style={{ marginTop: "20px", textAlign: 'center' }}>
                <button
                  disabled={processing}
                  style={{
                    backgroundColor: "#635bff",
                    color: "white",
                    border: "none",
                    padding: "12px 20px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => collectBankAccountForSetup(clientSecret,userDetail)}
                >
                  Retry Automatic Verification
                </button>
              </div>
              </>
              :
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <span><img src={indicator_icon} /></span>
              </div>
              }
              </div>
            </div>

          ) : showMandate ? (
            <div id='sgl-plugin-form'>
              <div 
                className="div-responsive"
                style={{
                  maxWidth: "600px",
                  margin: "auto",
                  padding: "20px",
                  fontFamily: "Arial, sans-serif",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9",
                  textAlign: 'left'
                }}
              >
              <h2 style={{ color: "#333", textAlign: "center" }}>
                Authorization for Bank Account Transactions
              </h2>
              <p>
                By clicking "Accept," you authorize {companyName} to debit the bank account specified
                below for any amount owed for charges arising from your use of {companyName} services
                and/or purchase of products from {companyName}, pursuant to {companyName} website and
                terms, until this authorization is revoked. You may amend or cancel this authorization
                at any time by providing notice to {companyName} with 30 (thirty) days notice.
              </p>
              <p>
                If you use {companyName} services or purchase additional products periodically
                pursuant to {companyName} terms, you authorize {companyName} to debit your bank
                account periodically. Payments that fall outside of the regular debits authorized
                above will only be debited after your authorization is obtained.
              </p>
              {bankAccount && (
                <p>
                  <strong>Bank Name:</strong> {bankAccount.bank_name} <br />
                  <strong>Account:</strong> {bankAccount.account_holder_name?`${bankAccount.account_holder_name} - `:""}*{bankAccount.last4}
                </p>
              )}
              {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
              {
              (!processing)?
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button
                  disabled={processing}
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    border: "none",
                    padding: "12px 20px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={handleConfirmMandate}
                  >
                    Accept
                  </button>
                </div>
                :
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <span><img src={indicator_icon} /></span>
                </div>
              }
              </div>
            </div>
          ) : (
            <div id='sgl-plugin-form'>
              <div 
                className="div-responsive"
                style={{
                  maxWidth: "600px",
                  margin: "auto",
                  padding: "20px",
                  fontFamily: "Arial, sans-serif",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9",
                  textAlign: 'left',
                }}
              >
              <h2 style={{ color: "#333", textAlign: "center" }}>
                Verify Your Bank Account Securely with Stripe
              </h2>
              <p style={{ color: "#555", fontSize: "16px", lineHeight: "1.5" }}>
                To process payments securely, we partner with <strong>Stripe</strong>, a trusted global
                payment provider. You will be guided through Stripe’s{" "}
                <strong>secure verification process</strong> to link and verify your bank account.
              </p>
              <h3 style={{ color: "#333" }}>🔹 Why is this necessary?</h3>
              <ul style={{ color: "#555", fontSize: "16px", lineHeight: "1.5" }}>
                <li>Ensures secure transactions and compliance with financial regulations.</li>
                <li>Protects against unauthorized access and fraud.</li>
                <li>Enables smooth and reliable ACH payments.</li>
              </ul>
              <p style={{ color: "#555", fontSize: "16px" }}>
                Click the button below to start the verification process.{" "}
                <strong>You must complete this step on Stripe’s secure platform to use ACH payments.</strong>
              </p>
              {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
              {
              (!processing)?
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button
                  disabled={processing}
                  style={{
                    backgroundColor: "#635bff",
                    color: "white",
                    border: "none",
                    padding: "12px 20px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={handleBankVerification}
                >
                  Start Bank Verification
                </button>
              </div>
              :
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <span><img src={indicator_icon} /></span>
              </div>
              }
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
} 
